import {Component, Input} from '@angular/core';
import {faBuilding as far} from '../../../../@theme/fortawesome/pro-regular-svg-icons';
import {faBuilding as fas} from '../../../../@theme/fortawesome/pro-solid-svg-icons';

@Component({
    selector: 'app-no-facility-message',
    template: `
        <app-illustration-message [class.full-height]="fullHeight"
                                  [hasTrees]="true"
                                  [title]="title"
                                  [caption]="caption">
        </app-illustration-message>
    `,
    animations: [],
})
export class NoFacilityMessageComponent {
    @Input() fullHeight = true;
    @Input() title = 'Please select a facility';
    @Input() caption = 'This view only works when a facility is selected. Please choose one.';
    icon = {far, fas};
}
